module.exports = __webpack_public_path__ + "Announcement.13d6e068.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Announcement/images/Announcement.png
// module id = JsbR
// module chunks = 0